<div>
  <span>Escolher um arquivo </span>
  <span>{{file ? file.name : 'ou arrastar e soltar aqui' }}</span>
  <input class="file-input" type="file" accept=".pdf, image/*">
</div>

<div class="mt-12 mb-12" *ngIf="progress > 0">
  <span>{{ progress }}%</span>
  <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
</div>

